import { getAlarmSettings } from './getAlarmSettings';
import { getBeautyInfo } from './getBeautyInfo';
import { getPocList } from './getPocList';
import { deletePoc } from './deletePoc';
import { patchMemberInfo } from './patchMemberInfo';
import { registerPoc } from './registerPoc';

export const myPageService = {
  getAlarmSettings: getAlarmSettings,
  getBeautyInfo: getBeautyInfo,
  getPocList: getPocList,
  deletePoc: deletePoc,
  patchMemberInfo: patchMemberInfo,
  registerPoc: registerPoc,
};
